// Filters

document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('[onchange*="handleSelectFilterWidth"]').forEach(function(el){
        handleSelectFilterWidth(el);
    });
});

function handleSelectFilterWidth(filter){
    filter.style.width = "calc(" + filter.selectedOptions[0].text.length + ".5ch + 55px)";
};

function resetFilters(filter){
    if (filter.getAttribute('name') == "fproduct") {
        var form = filter.form;
        form.querySelectorAll('select').forEach((input) => {            
            if (input.getAttribute('name') == "fproduct" || input.classList.contains('disabled') == true) {
                return;
            }            
            input.options[0].selected = 'selected';
        });
    }
};